import React, { useState, useCallback } from 'react';

const SUPPORT_EMAIL = 'support@clicktube.co.il';

interface SupportEmailLinkProps {
  className?: string;
  /** If true, show full "תמיכה: support@clicktube.co.il"; otherwise just "תמיכה" */
  showEmail?: boolean;
}

const SupportEmailLink: React.FC<SupportEmailLinkProps> = ({ className = '', showEmail = true }) => {
  const [copied, setCopied] = useState(false);

  const handleClick = useCallback(async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
      setCopied(true);
      const t = window.setTimeout(() => {
        setCopied(false);
        window.clearTimeout(t);
      }, 2000);
    } catch {
      // fallback: open mailto
      window.location.href = `mailto:${SUPPORT_EMAIL}`;
    }
  }, []);

  const label = showEmail ? `תמיכה: ${SUPPORT_EMAIL}` : 'תמיכה';

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`bg-transparent border-0 p-0 cursor-pointer text-inherit hover:opacity-90 transition-opacity focus:outline-none focus:ring-0 ${className}`}
    >
      {copied ? 'הכתובת הועתקה' : label}
    </button>
  );
};

export default SupportEmailLink;
